import { useTranslation } from 'react-i18next';

import { GrayButton } from 'libs/ui';
// import { zones } from 'services/zones';
import { ScheduleRow } from './blocks/schedule-row';
import { Content, Table, Scroll } from './schedule.styled';

const def = {
  time_at: '00:00:00',
  mode: 'regular',
  weekdays: 0,
};

export const Schedule = (props) => {
  const { t } = useTranslation();

  const { data, onChange } = props;

  /**
   * change limit
   * @param {*} idx
   * @param {*} event
   */
  const change = (id, name, val) => {
    const out = data.splice(0);
    out[id][name] = val;
    // console.log('🚀 ~ change ~ out:', out);
    onChange(out);
  };

  /**
   *  add new row
   */
  const add = () => {
    // const items = zones.getZones();
    const out = data.splice(0);
    out.push({ ...JSON.parse(JSON.stringify(def)) });
    onChange(out);
  };

  /**
   * del row
   * @param {*} id
   */
  const del = (idx) => {
    const out = data.splice(0);
    out.splice(idx, 1);
    onChange(out);
  };

  const getRowsEl = () => {
    return data.map((el, idx) => {
      const row = { ...el };
      return <ScheduleRow key={idx} row={row} id={idx} onChange={change} onDel={del} />;
    });
  };

  const rowsEl = getRowsEl();
  const withData = data && data.length > 0;

  return (
    <Content>
      {!withData ? (
        <p>{t('messages.Данные отсутствуют')}</p>
      ) : (
        <Scroll>
          <Table>
            <thead>
              <tr>
                <th width="170" rowSpan={2}>
                  {t('windows.Режим')}
                </th>
                <th width="160" rowSpan={2}>
                  {t('windows.Время включения')}
                </th>
                <th colSpan={7} className="center">
                  {t('windows.Дни недели')}
                </th>
                <th rowSpan={2}></th>
              </tr>
              <tr>
                <th>{t('windows.Пн')}</th>
                <th>{t('windows.Вт')}</th>
                <th>{t('windows.Ср')}</th>
                <th>{t('windows.Чт')}</th>
                <th>{t('windows.Пт')}</th>
                <th>{t('windows.Сб')}</th>
                <th>{t('windows.Вс')}</th>
              </tr>
            </thead>
            <tbody>{rowsEl}</tbody>
          </Table>
        </Scroll>
      )}

      <GrayButton onClick={add}>{t('buttons.Добавить расписание')}</GrayButton>
    </Content>
  );
};
